import {ChangeDetectionStrategy, Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {BehaviorSubject, Observable, Subscription} from 'rxjs';
import {distinctUntilChanged, map, throttleTime} from 'rxjs/operators';
import {AuthenticationService} from 'src/app/auth/auth.service';
import {MobileService} from 'src/app/core/page/mobile.service';
import {selectRouterDataEntry, selectRouterUrl} from 'src/app/core/store/router/router.selector';
import {Lens} from 'src/app/lenses/shared/model/lens';
import {selectActiveUser, selectActiveUserLens} from '../../../core/store/active-user/active-user.selector';

@Component({
  selector: 'mobile-layout',
  templateUrl: './mobile-layout.component.html',
  styleUrls: ['./mobile-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileLayoutComponent implements OnInit, OnDestroy {
  public routerUrl$: Observable<string>;
  public lens$: Observable<Lens>;
  public phone$: Observable<boolean>;
  showTopbar$: Observable<boolean>;
  showNavbar$: Observable<boolean>;
  public activeUser$ = this.store$.select(selectActiveUser);

  screenWidth$ = new BehaviorSubject<number>(null);

  private subscriptions = new Subscription();

  @HostListener('window:resize', ['$event'])
  onWindowResize(event: Event) {
    this.screenWidth$.next(window.innerWidth);
  }

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private mobileService: MobileService,
    private store$: Store
  ) {}

  public ngOnInit() {
    this.screenWidth$.next(window.innerWidth);
    this.routerUrl$ = this.store$.select(selectRouterUrl);
    this.showNavbar$ = this.store$.select(selectRouterDataEntry('mobileNavShown')).pipe(map(val => val !== false));
    this.lens$ = this.store$.select(selectActiveUserLens);
    this.phone$ = this.mobileService.observePhone().pipe(throttleTime(500));

    this.subscriptions.add(this.subscribeToPhone());
  }

  private subscribeToPhone(): Subscription {
    return this.phone$.pipe(distinctUntilChanged()).subscribe(phone => {
      if (phone) {
        // this.router.navigate(['current-sked']);
      }
    });
  }

  public onLogout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    document.body.style.overflow = '';
  }
}
